import { render } from "./PairScore.vue?vue&type=template&id=05d52909"
import script from "./PairScore.vue?vue&type=script&lang=js"
export * from "./PairScore.vue?vue&type=script&lang=js"

import "./PairScore.vue?vue&type=style&index=0&id=05d52909&lang=css"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__